<template>
  <div>
    <v-layout wrap>
      <v-flex pt-4 xs12>
        <v-layout wrap justify-start>
          <v-flex xs3>
            <Filters />
          </v-flex>
          <v-flex xs1 ma-n12>
            <v-divider vertical></v-divider>
          </v-flex>
          <v-flex xs8>
            <Product />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Filters from "./filters";
import Product from "./product";
export default {
  components: { Filters, Product },
  data() {
    return {};
  },
};
</script>